module.exports = __webpack_public_path__ + "img/jk_summary_Image.83618c8e.png";